export enum ESubscriptionPaymentOption {
	MEGAFON = 'megafon',
	TELE2 = 'tele2',
	UNKNOWN = 'unknown',
}

export enum ESubscriptionResult {
	SUCCESS = 'success',
	ERROR = 'error',
}

export enum ESubscriptionCancelPage {
	TARIFF_CAROUSEL = 'tariff_carousel',
	PHONE_INPUT = 'phone_input',
	SMS_INPUT = 'sms_input',
	SMS_REQUEST = 'sms_request',
	SUCCESS = 'success',
	ERROR = 'error',
	TERMS = 'terms',
}
